import React, {FC} from 'react';

import QuestionRadio from '../../components/QuestionRadio';
import {RETIREMENT_OPTIONS} from '../../constants';

const StepRetirement: FC = () => (
  <QuestionRadio field="retirement" options={RETIREMENT_OPTIONS} />
);

export default StepRetirement;
